class SwapToOrdinaryMan extends HTMLElement {
  constructor() {
    super();

    this.button = this.querySelector('button');
    this.messageContainer = null;
    this.subscriptionId = this.getSubscriptionIdFromUrl();
    this.targetProductSku = this.getAttribute('data-target-product-sku');
    this.productId = this.getAttribute('data-product-id');
    this.variantId = this.getAttribute('data-variant-id');
    this.init();
  }

  init() {
    // Hide component if no subscription_id in URL
    if (!this.subscriptionId) {
      this.style.display = 'none';
      return;
    }
    // hide the [data-type="add-to-cart-form"]

    const addToCartForm = document.querySelector('[data-type="add-to-cart-form"]');
    if (addToCartForm) {
      addToCartForm.style.display = 'none';
    }

    // Create message container
    this.createMessageContainer();

    // Bind button click handler
    if (this.button) {
      this.button.addEventListener('click', this.handleSwap.bind(this));
    }
  }

  getSubscriptionIdFromUrl() {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get('recharge_subscription_id');
  }

  createMessageContainer() {
    this.messageContainer = document.createElement('div');
    this.messageContainer.className = 'swap-message';
    this.messageContainer.setAttribute('role', 'status');
    this.messageContainer.setAttribute('aria-live', 'polite');
    this.appendChild(this.messageContainer);
  }

  showMessage(message, type = 'info') {
    if (!this.messageContainer) return;

    this.messageContainer.textContent = message;
    this.messageContainer.className = `swap-message swap-message--${type}`;
    this.messageContainer.style.display = 'block';
  }

  hideMessage() {
    if (this.messageContainer) {
      this.messageContainer.style.display = 'none';
    }
  }

  setButtonLoading(isLoading) {
    if (!this.button) return;

    if (isLoading) {
      this.button.setAttribute('disabled', true);
      this.button.setAttribute('aria-disabled', 'true');
      this.button.setAttribute('aria-busy', 'true');
    } else {
      this.button.removeAttribute('disabled');
      this.button.removeAttribute('aria-disabled');
      this.button.removeAttribute('aria-busy');
    }
  }

  async handleSwap(event) {
    event.preventDefault();

    if (!this.subscriptionId) {
      this.showMessage('No subscription ID found', 'error');
      return;
    }

    // Set loading state
    this.setButtonLoading(true);
    this.hideMessage();

    try {
      //const appUrl  = `https://bob-swap-to-new-scent-5bf28596048c.herokuapp.com`
      const appUrl = `http://localhost:3000`;
      const response = await fetch(`${appUrl}/update-bundle-selection`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          subscription_id: this.subscriptionId,
          target_product_sku: this.targetProductSku,
          product_id: this.productId,
          variant_id: this.variantId,
        }),
      });

      const data = await response.json();

      if (response.ok) {
        this.showMessage(data.message || 'Subscription updated successfully!', 'success');
      } else {
        this.showMessage(data.error || data.message || 'Failed to update subscription', 'error');
      }
    } catch (error) {
      console.error('Error updating subscription:', error);
      this.showMessage('An error occurred while updating your subscription. Please try again.', 'error');
    } finally {
      // Remove loading state
      this.setButtonLoading(false);
    }
  }
}

customElements.define('swap-to-another-refill', SwapToOrdinaryMan);
